import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Services
import AnnouncementService from '../../services/announcement-service';
import ClassroomService from '../../services/classroom-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';
import FileStorageService from '../../services/file-storage-service';

// Containers
import AnnouncementFollow from './announcement-follow';
import AnnouncementEdit from './announcement-edit';

// Components
import Loading from '../../components/loading/loading';
import ErrorComponent from '../../components/error/error';

const AnnouncementEditFollow = () => {
  const { announcementId } = useParams<{ announcementId: string }>();
  const [error, setError] = useState(false);

  const [active, setActive] = useState<boolean | null>(null);
  const [announcement, setAnnouncement] = useState<AnnouncementDto>(null);
  const [announcementDetail, setAnnouncementDetail] =
    useState<BackofficeAnnouncementDetailDto>(null);
  const [classroomList, setClassroomList] = useState<ClassroomStudents[] | null>(null);
  const [announcementService, setAnnouncementService] = useState<AnnouncementService | null>(null);
  const [fileStorageService, setFileStorageService] = useState<FileStorageService | null>(null);

  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    let service: AnnouncementService;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => {
        service = new AnnouncementService(school.uuid);

        setAnnouncementService(service);
        setFileStorageService(new FileStorageService(school.uuid));

        return service.getBackoffice(announcementId);
      })
      .then((detail) => {
        setActive(detail.isScheduled);

        if (detail.isScheduled) {
          // Editing still needs the canonical DTO + classroom roster to drive the
          // student selector (recipientsToStudentIds / buildAnnouncementRequest).
          const classroomService = new ClassroomService();

          return Promise.all([
            service.getAnnouncement(announcementId),
            classroomService.listClassroomStudents(),
          ]).then(([fullAnnouncement, classrooms]) => {
            setAnnouncement(fullAnnouncement);
            setClassroomList(classrooms);
          });
        }

        setAnnouncementDetail(detail);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (active === null || !announcementService || !fileStorageService)
    return <Loading type='contentFull' />;

  if (active) {
    if (!announcement || !classroomList) return <Loading type='contentFull' />;

    return (
      <AnnouncementEdit
        announcement={announcement}
        classroomList={classroomList}
        announcementService={announcementService}
        fileStorageService={fileStorageService}
      />
    );
  }

  if (!announcementDetail) return <Loading type='contentFull' />;

  return (
    <AnnouncementFollow
      announcement={announcementDetail}
      announcementService={announcementService}
    />
  );
};

export default AnnouncementEditFollow;
